<template>
<div class="ts-app-shell_fh">
    <div class="padd-main">
        <div class="ts-app-shell--header">
            <h5>
                <strong>View Role</strong>
            </h5>
            <div class="ts-app-shell--header_actions" style="right: 0; padding-right: 210px;position: absolute;">
                <el-button @click="backToRoleMatches">Back to Role Matches</el-button>   
            </div>
            <div class="ts-app-shell--header_actions" style="right: 0; padding-right: 60px;position: absolute;">
                <el-button class="btn-dark" @click="applyForRole">Apply for Role</el-button>      
            </div>
                        
        </div>

        <el-divider></el-divider>

        <RolePostingDetails 
            :VacantRoleInfo="vacantInfo" 
            :ShowComponent="showComponent"/>        

    </div>
</div>
</template>

<script>

import RolePostingDetails from '../../../components/workflow/RolePostingDetails.vue';

export default {
    components : {
        RolePostingDetails
    },
    methods: {
        backToRoleMatches() {
            this.$router.push({ name: "role-matching-apprentice" });
        },
        applyForRole() {
            this.$router.push({ name: 'ConfirmApplyForApprenticeRoleDialog', params: { data: this.match }});
        }
    },
    data() {
        return {
            showComponent: false,
            companybranding: null,
            vacantInfo: {},
            match: {}
        }
    },
    created() {
        var vacantId = this.$route.params.vacantid;
        this.match = this.$route.params.matchdetail;

        this.$store.dispatch('jobseeker/getRoleInfo', vacantId)
          .then((res) => {    
            this.vacantInfo = res;
            this.showComponent = true;
          });
    },
    
}
</script>

<style>
.btn-dark {
  background-color: #14223c;
  color: white;
}
</style>